let e = 0;
function d(t) {
  const n = (t?.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase() ?? "uid") + e;
  return e += 1, n;
}
export {
  d as getUniqueId
};
//# sourceMappingURL=index.js.map
